import { createContext, useContext } from "react";

import { useLineChartActionsHookFactory } from "./hooks";

const Context = createContext({})
const useLineChartActions = () => useContext(Context)

const LineChartProvider = ({ children }) => {
  const actions = useLineChartActionsHookFactory()

  return <Context.Provider value={{ actions }}>
    {children}
  </Context.Provider>
}

export {
  useLineChartActions,
  LineChartProvider,
}
